import React from "react";

const CustomPopupModal = ({ modal, onClose }) => {
  if (!modal) return null;

  const isQuestion = modal.type == 1;
  const hasImage = modal.fullImage && modal.fullImage !== "";

  // Default button for message modal
  const defaultButton = (
    <button
      onClick={onClose}
      className="px-5 py-2.5 rounded-lg bg-gradient-to-r from-emerald-500 to-green-600 
               text-white font-semibold shadow-md hover:opacity-90 transition-all duration-300"
    >
      OK
    </button>
  );

  return (
    <div
      className="fixed inset-0 flex justify-center items-center z-[9999] 
                 bg-black/40 backdrop-blur-sm animate-fadeIn"
    >
      <div
        className="relative p-6 w-[90%] max-w-md rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.4)] 
                   animate-popUp transition-all duration-300"
        style={{
          background: hasImage ? "transparent" : modal.backgroundcolor,
          backgroundImage: hasImage ? `url(${modal.fullImage})` : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* 🔥 Overlay for readability when image is present */}
        {hasImage && (
          <div className="absolute inset-0 bg-black/40 backdrop-blur-[1px] rounded-2xl"></div>
        )}

        {/* Content */}
        <div className="relative z-10">
          {/* Title */}
          <h2
            className="text-2xl font-extrabold mb-3 tracking-wide drop-shadow-lg animate-slideDown"
            style={{ color: modal.titlecolor }}
          >
            {modal.title}
          </h2>

          {/* Description */}
          <div
            className="text-sm leading-relaxed mb-6 text-white/90 animate-slideUp"
            dangerouslySetInnerHTML={{ __html: modal.description }}
          />

          {/* Buttons */}
          <div className="flex justify-end gap-3 mt-4 animate-fadeIn">
            {/* ⭐ TYPE 0 → default button */}
            {!isQuestion && defaultButton}

            {/* ⭐ TYPE 1 → custom buttons */}
            {isQuestion && (
              <>
                {modal.is_btn2 == 1 && (
                  <button
                    onClick={onClose}
                    style={{
                      background: modal.btn2_color,
                      color: modal.btn2_font,
                    }}
                    className="px-4 py-2 rounded-lg shadow hover:opacity-90 transition-all duration-300"
                  >
                    {modal.btn2_text || "No"}
                  </button>
                )}

                {modal.is_btn1 == 1 && (
                  <button
                    onClick={onClose}
                    style={{
                      background: modal.btn1_color,
                      color: modal.btn1_font,
                    }}
                    className="px-4 py-2 rounded-lg shadow hover:opacity-90 transition-all duration-300"
                  >
                    {modal.btn1_text || "Yes"}
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* ⭐ ANIMATIONS ⭐ */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-fadeIn {
          animation: fadeIn 0.35s ease-out forwards;
        }

        @keyframes popUp {
          0% { transform: scale(0.7); opacity: 0; }
          80% { transform: scale(1.03); opacity: 1; }
          100% { transform: scale(1); }
        }
        .animate-popUp {
          animation: popUp 0.35s ease-out forwards;
        }

        @keyframes slideDown {
          from { transform: translateY(-10px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-slideDown {
          animation: slideDown 0.45s ease-out forwards;
        }

        @keyframes slideUp {
          from { transform: translateY(10px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-slideUp {
          animation: slideUp 0.45s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default CustomPopupModal;
